import React, { useMemo } from "react";
import { GetFilteredVendorOffers } from "../../../../../Services";
import {
  AutocompleteComponent,
  CustomAutocomplete,
  ReskinningAutocomplete,
} from "../../../../../Components";
import useFetchData from "../../../../../Hooks/useFetchData";
import { useLayoutDetection } from "../../../../../Hooks";
import { is } from "core-js/core/object";

const OfferAutocomplete = ({
  vendorId,
  serviceCategoryName,
  onChange,
  ...props
}) => {
  const params = useMemo(
    () => ({
      pageSize: 25,
      pageIndex: 1,
      vendorId,
      serviceCategoryName,
    }),
    [vendorId, serviceCategoryName]
  );
  const { isNewLayout: isReskinningLayout, hasNewLayout } =
    useLayoutDetection();
  const { data, loading } = useFetchData(GetFilteredVendorOffers, params);
  const isNewLayout = isReskinningLayout && hasNewLayout;

  return !isNewLayout ? (
    <AutocompleteComponent
      data={data?.result ?? []}
      isDisabled={loading || !vendorId || !serviceCategoryName}
      isLoading={loading}
      withoutSearchButton
      displayLabel={(option) => option.offerName ?? ""}
      multiple={false}
      onChange={(_e, newValue) => onChange(newValue)}
      {...props}
    />
  ) : (
    <ReskinningAutocomplete
      data={data?.result ?? []}
      isDisabled={loading || !vendorId || !serviceCategoryName}
      isLoading={loading}
      withoutSearchButton
      displayLabel={(option) => option.offerName ?? ""}
      multiple={false}
      onChange={(_e, newValue) => onChange(newValue)}
      {...props}
    />
  );
};
export default OfferAutocomplete;
